/**
 * Major world airlines for travel activity airline selection.
 * Sorted alphabetically by name. IATA code included where common.
 */
export const AIRLINES = [
  { code: 'AA', name: 'American Airlines' },
  { code: 'AC', name: 'Air Canada' },
  { code: 'AF', name: 'Air France' },
  { code: 'AM', name: 'Aeromexico' },
  { code: 'AS', name: 'Alaska Airlines' },
  { code: 'AV', name: 'Avianca' },
  { code: 'AY', name: 'Finnair' },
  { code: 'AZ', name: 'ITA Airways' },
  { code: 'BA', name: 'British Airways' },
  { code: 'B6', name: 'JetBlue' },
  { code: 'BR', name: 'EVA Air' },
  { code: 'CX', name: 'Cathay Pacific' },
  { code: 'DL', name: 'Delta Air Lines' },
  { code: 'EI', name: 'Aer Lingus' },
  { code: 'EK', name: 'Emirates' },
  { code: 'ET', name: 'Ethiopian Airlines' },
  { code: 'EY', name: 'Etihad Airways' },
  { code: 'FI', name: 'Icelandair' },
  { code: 'FR', name: 'Ryanair' },
  { code: 'FZ', name: 'flydubai' },
  { code: 'G3', name: 'GOL' },
  { code: 'IB', name: 'Iberia' },
  { code: 'JL', name: 'Japan Airlines' },
  { code: 'JU', name: 'Air Serbia' },
  { code: 'KL', name: 'KLM' },
  { code: 'LA', name: 'LATAM Airlines' },
  { code: 'LH', name: 'Lufthansa' },
  { code: 'LX', name: 'Swiss International Air Lines' },
  { code: 'NH', name: 'All Nippon Airways (ANA)' },
  { code: 'NZ', name: 'Air New Zealand' },
  { code: 'QF', name: 'Qantas' },
  { code: 'QR', name: 'Qatar Airways' },
  { code: 'SA', name: 'South African Airways' },
  { code: 'SK', name: 'Scandinavian Airlines (SAS)' },
  { code: 'SQ', name: 'Singapore Airlines' },
  { code: 'TK', name: 'Turkish Airlines' },
  { code: 'UA', name: 'United Airlines' },
  { code: 'U2', name: 'easyJet' },
  { code: 'UK', name: 'Vistara' },
  { code: 'VS', name: 'Virgin Atlantic' },
  { code: 'W6', name: 'Wizz Air' },
  { code: 'WN', name: 'Southwest Airlines' },
];
